import React from "react"
import ReminderSettingsForm from "src/features/collections/components/ReminderSettingsForm"

export default function CollectionSettingsPage() {
  return <ReminderSettingsForm />
}
